import { pathDepth } from "../../../boundaries/url-path.parser";

type ClusterLabelEvidence = {
  path: string;
  title?: string | null;
};

/** Finds an initialism supported by external page-title evidence. */
export function inferredClusterInitialism(
  key: string,
  pages: readonly ClusterLabelEvidence[],
): string | null {
  if (!/^[a-z]{2,5}$/.test(key)) return null;
  const ordered = [...pages].sort(
    (left, right) =>
      pathDepth(left.path) - pathDepth(right.path) ||
      left.path.localeCompare(right.path),
  );
  for (const page of ordered) {
    const title = page.title?.split(/\s(?:\||:)\s|\||:/)[0]?.trim();
    if (!title) continue;
    const words = title.match(/[A-Za-z0-9]+/g) ?? [];
    const firstWord = words[0];
    if (
      firstWord?.toLowerCase() === key &&
      firstWord === firstWord.toUpperCase()
    ) {
      return firstWord;
    }
    const initials = words
      .slice(0, key.length)
      .map((word) => word.charAt(0))
      .join("");
    if (initials.toLowerCase() === key) return initials.toUpperCase();
  }
  return null;
}
